import { render, staticRenderFns } from "./ModalDownload.vue?vue&type=template&id=3f7d8715&scoped=true"
import script from "./ModalDownload.vue?vue&type=script&lang=js"
export * from "./ModalDownload.vue?vue&type=script&lang=js"
import style0 from "./ModalDownload.vue?vue&type=style&index=0&id=3f7d8715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7d8715",
  null
  
)

export default component.exports